let globalForceSave: (() => void) | null = null;

export const getGlobalForceSave = () => globalForceSave;

export const setGlobalForceSave = (fn: (() => void) | null) => {
    globalForceSave = fn;
};
